import React from 'react'
import Link from 'next/link'
import { Button } from "@nextui-org/react";


export default function SideBarLink(props) {
  const {link, isActive, index} = props
  return (
    <Button color={'primary'} as={Link} href={link.href} className="px-4 w-full text-sm font-semibold" variant={isActive ? `solid` : `light`}>
      <span className="truncate">{link.name}</span>
    </Button>
  )
}
